module.exports = "<ng-container>{{ _data }}</ng-container>\n"